import * as React from 'react';
import { Crumb } from '@liveauctioneers/caterwaul-components/lib/Breadcrumbs/Breadcrumbs';
import { getCatalogUrl } from '@/utils/urls';
import { getItemModelCatalogId, getItemModelCatalogTitle } from '@/redux/modules/item/summary/itemSummary.selectors';
import { NewAccountWalkthroughSteps } from '@/types/walkthroughs';
import { PreviousLocationContext } from '@/components/PreviousLocation/PreviousLocation';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useNavigate } from 'react-router-dom';

const useBackBreadcrumb = (itemId: number): Crumb => {
    const { formatMessage } = useIntl();
    const navigate = useNavigate();
    const catalogId = useAppSelector((state) => getItemModelCatalogId(state, itemId));
    const title = useAppSelector((state) => getItemModelCatalogTitle(state, itemId));
    const { pathname } = React.useContext(PreviousLocationContext);

    if (pathname.includes('/search') || pathname.includes('/c/') || pathname.includes('/price-guide')) {
        return {
            back: true,
            label: formatMessage({ id: 'back_to_search' }),
            onClick: () => navigate(-1),
        };
    } else if (pathname.includes('catalog') && pathname.includes(`${catalogId}`)) {
        return {
            back: true,
            label: formatMessage({ id: 'back_to_auction' }),
            onClick: () => navigate(-1),
        };
    }

    if (!catalogId) {
        return {} as Crumb;
    }

    const catalogUrl = getCatalogUrl(catalogId, title);
    return {
        back: true,
        label: (
            <span data-walkthrough-step={NewAccountWalkthroughSteps.Item2}>
                {formatMessage({ id: 'view_auction' })}
            </span>
        ),
        link: catalogUrl,
    };
};

export default useBackBreadcrumb;
